import { useLogout, useCurrentUser } from "utils/hooks";
import { toast } from "react-toastify";
import { User } from "types";

interface resendOrganizationInviteProps {
  member: User;
}

const useResendOrganizationInvite = () => {
  const { user } = useCurrentUser();
  const { logOut } = useLogout();

  const resendOrganizationInvite = async ({
    member,
  }: resendOrganizationInviteProps) => {
    const { email } = member;

    const mutation = `
          mutation {
            resendOrganizationInvite(
              email: "${email}",
            ) {
              success
              error
            }
        }
      `;

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
          ${mutation}
        `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "invite_organization_therapist",
        },
      });

      const resData = await res.json();

      if (res.ok && resData.data.resendOrganizationInvite.success) {
        toast("Invitation has been resent");
        return true;
      }
      if (res.ok && resData.data.resendOrganizationInvite.error) {
        toast(`${resData.data.resendOrganizationInvite.error}`);
        return false;
      }

      if (!res.ok) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
        return false;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  return {
    resendOrganizationInvite,
  };
};

export default useResendOrganizationInvite;
